import { HttpClient as HttpImplementation } from '@remote-data/http-client/types';
import { axiosRequest } from '@remote-data/axios-request';

export class HttpClient implements HttpImplementation {
  request = axiosRequest;
}

export default new HttpClient();
